module.exports = __webpack_public_path__ + "img/kr-red-card-right-bottom-5.98c1d81.png";